import { useState, useEffect, useContext, useCallback, useRef } from "react";
import { useStopwatch } from "react-timer-hook";
import { BsChevronDown, BsChevronUp, BsExclamationTriangle, BsPencilFill, BsEye, BsEyeSlash, BsJournalText, BsShare } from "react-icons/bs";
import { CiCalculator1 } from "react-icons/ci";
import { VscReferences } from "react-icons/vsc";
import { BsThreeDotsVertical } from "react-icons/bs";
import Question from "./MathQuestion";
import axios from "axios";
import Timer from "./Timer";
import { motion } from "framer-motion";
import { UserContext } from "../../context/UserContext";
import { useLocation } from "react-router-dom";
import { BASELINE } from "../../util";
import Review from "./Review";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import DirectionModal from './DirectionModal';
import ReferenceSheet from './ReferenceSheet';
import { AiOutlineSave } from 'react-icons/ai';
import { v4 as uuidv4 } from 'uuid';
import Modal from "react-modal"; // Example of using react-modal for the modal
import { FaKey } from "react-icons/fa6";
import { FaChalkboard } from "react-icons/fa";
import AIAudioPlayer from '../aivoice/AIAudioComponent';
import { toPng } from 'html-to-image';
import { MdDashboard } from "react-icons/md";
import QuestionOverview from "./Question_Overview";
import { FaComments } from "react-icons/fa";

const SATQuiz = () => {
  const navigate = useNavigate();
  const boxItemLeftRef = useRef();
  const { user } = useContext(UserContext);
  // Prevents handleLocalStorageData from being called by two separate useEffects
  // on the same mount, which caused double API calls and competing timer starts.
  const initRef = useRef(false);

  // Highlight mode: ON/OFF stored in a cookie so it persists across page visits.
  // Actual highlight data is in highlightsRef (in-memory): survives question
  // navigation within the session but resets when the user leaves the page.
  const [highlightMode, setHighlightMode] = useState(() => {
    try {
      const c = document.cookie.split('; ').find(r => r.startsWith('highlightMode='));
      return c?.split('=')[1] === 'true';
    } catch { return false; }
  });
  const highlightsRef = useRef({});
  const prevQuestionIdRef = useRef(null);
  const [showCalculator, setShowCalculator] = useState(false);
  const [questionOverViewOpen, setQuestionOverviewOpen] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [bookmarkedQuestions, setBookMarkedQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [showDirectionModal, setShowDirectionModal] = useState(false);
  const [loadingQuestions, setLoadingQuestions] = useState(false);
  const [showDirectionModalRef, setShowDirectionRefModal] = useState(false);
  const [test_id, settest_id] = useState(() => {
    const navType = performance.getEntriesByType?.('navigation')?.[0]?.type;
    // 'navigate' = 대시보드에서 새 퀴즈 시작 → 새 UUID
    // 'reload' / 'back_forward' / undefined = 복귀 → 기존 세션 재사용
    if (navType !== 'navigate') {
      return sessionStorage.getItem('activeTestId') || uuidv4();
    }
    return uuidv4();
  });
  const isSubmittingRef = useRef(false);
  const [disablesave, setdisablesave] = useState(true);
  const [showOptions, setShowOptions] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [context, setContext] = useState('');

  const location = useLocation();
  const responseData = location.state?.data;
  const blitzModeActive = responseData?.blitzModeActive;
  const blitzTimeLimit = responseData?.blitzTimeLimit ? Number(responseData.blitzTimeLimit) : 30;
  const [blitzQuestionTimeLeft, setBlitzQuestionTimeLeft] = useState(null);
  const blitzIntervalRef = useRef(null);
  const [timeLeft, setTimeLeft] = useState(null); // Countdown timer
  const [timerActive, setTimerActive] = useState(false); // Track if countdown timer is active
  const { start, reset } = useStopwatch({ autoStart: false }); // Use stopwatch for untimed mode

  const displayMinutes = Math.floor(timeLeft / 60);
  const displaySeconds = timeLeft % 60;

  const [questionsarr, setquestionsarr] = useState([]);
  const [result, setResult] = useState([]);
  const [questionTimers, setQuestionTimers] = useState([]);

  const [askedConfirmation, setAskedConfirmation] = useState([]);

  const [username, setUsername] = useState(""); // State for username input
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [c, setc] = useState(false);
  const [showanswer, setshowanswer] = useState(false);
  const [autotimer, setautotimer] = useState(false);
  const [autotutor, setautotutor] = useState(false);
  const [qarr, setqarr] = useState([]);
  const [auto, setauto] = useState(false);
  const [autotype, setsutotpye] = useState("");
  const [publicnotes, setpublicnotes] = useState([]);
  const [publicnotesuserid, setpublicnotesuserid] = useState("");
  const [privatenotes, setprivatenotes] = useState([]);
  const [rewritenotes, setrewritenotes] = useState([]);
  const [savednotes, setsavednotes] = useState([]);
  const [showWhiteboard, setShowWhiteboard] = useState(false); // State to control whiteboard visibility
  const quizContentRef = useRef(); // Reference to the quiz content for the screenshot
  const [screenshotData, setScreenshotData] = useState(null);
  const [original_tid, setoriginal_tid] = useState("");
  const [submitClicked, setSubmitClicked] = useState(false);
  const [isSharing, setIsSharing] = useState(false);

  const [isChatVisible, setIsChatVisible] = useState(false);
  const toggleChat = () => setIsChatVisible(prev => !prev);

  const [showTimer, setShowTimer] = useState(true);
  const [showNotes, setShowNotes] = useState(false);
  const [notesText, setNotesText] = useState('');

  const aicontext = currentQuestion?.questionIds ? `
        You are a caring and encouraging college teacher assisting a student in understanding a problem. Please follow these instructions carefully:
        1. Do NOT include any greeting words (e.g., "Hi", "Hello") in your output.
        2. Provide a 15-word introduction that sets a supportive tone while explaining the aim.
        3. Offer a gentle, step-by-step explanation guiding the student toward the correct answer.
        4. Present your response in JSON format with two keys: "greeting" and "stepbystep".

        - "greeting": an array containing exactly one string of 15 words (no more, no less).
        - "stepbystep": an array of strings, each describing one step of the explanation.

        Here is the problem:

        <Question> ${currentQuestion.stem} ${currentQuestion.stimulus} </Question>
        <option list>
        ${currentQuestion.a}
        ${currentQuestion.b}
        ${currentQuestion.c}
        ${currentQuestion.d}
        </option list>
        <answer> ${JSON.parse(currentQuestion.correct_answer)} </answer>
        <step by step> ${currentQuestion.rationale} </step by step>

        [[MAKE sure the output does not have the Latex, Only in English]]
        Example Output:
        {
          "greeting": ["This is a brief introduction to help you solve the problem."],
          "stepbystep": [
            "Step 1: Identify the main question being asked.",
            "Step 2: .....",
            "...",
            "Step N: ....."
          ]
        }
      ` : "";

  useEffect(() => {
    const script2 = document.createElement("script");
    script2.src =
      "https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/contrib/auto-render.min.js";
    script2.integrity =
      "sha384-+VBxd3r6XgURycqtZ117nYw44OOcIax56Z4dCRWbxyPt0Koah1uHoK0o4+/RRE05";
    script2.crossOrigin = "anonymous";
    script2.defer = true;

    // Handle script load
    script2.onload = () => {
      const elements = document.querySelectorAll(".box-item-left");
      elements.forEach((element) => {
        if (window.renderMathInElement) {
          window.renderMathInElement(element, {
            delimiters: [
              { left: "$$", right: "$$", display: false },
              { left: "$", right: "$", display: false },
              { left: "\\(", right: "\\)", display: false },
              { left: "\\[", right: "\\]", display: true },
              { left: "\\begin{array}", right: "\\end{array}", display: true },
            ],
            throwOnError: false,
          });
        }
      });
    };
    document.body.appendChild(script2);

    // Cleanup: remove the script when component unmounts
    return () => {
      document.body.removeChild(script2);
    };
  }, [currentQuestion, result]);

  const toggleWhiteboard = async (userid) => {
    setpublicnotesuserid(userid);
    setShowWhiteboard(!showWhiteboard);
    if (userid) {
      try {
        const response = await axios.post(BASELINE + 'whiteboard/view/add/by/id', { id: userid });
      } catch (error) {
        console.error('Error sending initial data:', error);
      }
    }

    if (!showWhiteboard) {
      if (quizContentRef.current && currentQuestion.a) {
        // 1) DOM 실제 크기를 줄이기 (transform)
        quizContentRef.current.style.transform = 'scale(0.96, 0.5)';
        quizContentRef.current.style.transformOrigin = 'center top';
        quizContentRef.current.style.marginTop = "20px";

        toPng(quizContentRef.current, {
          backgroundColor: 'white', // 배경색 지정
          skipFonts: true,
        })
          .then((dataURL) => {
            // 2) 캡처 후, transform 원상 복구
            quizContentRef.current.style.transform = '';
            quizContentRef.current.style.transformOrigin = '';

            setScreenshotData(dataURL);
          })
          .catch((error) => {
            quizContentRef.current.style.transform = '';
            quizContentRef.current.style.transformOrigin = '';

            console.error('Oops, something went wrong!', error);
          });
      } else {
        // 1) DOM 실제 크기를 줄이기 (transform)
        quizContentRef.current.style.transform = 'scale(1, 1)';
        quizContentRef.current.style.transformOrigin = 'center top';
        quizContentRef.current.style.marginTop = "10px";

        toPng(quizContentRef.current, {
          backgroundColor: 'white', // 배경색 지정
          skipFonts: true,
        })
          .then((dataURL) => {
            // 2) 캡처 후, transform 원상 복구
            quizContentRef.current.style.transform = '';
            quizContentRef.current.style.transformOrigin = '';

            setScreenshotData(dataURL);
          })
          .catch((error) => {
            quizContentRef.current.style.transform = '';
            quizContentRef.current.style.transformOrigin = '';

            console.error('Oops, something went wrong!', error);
          });
      }
    }
  };


  useEffect(() => {
    if (user?.role === 'teacher') return;

    let timerInterval;
    if (timerActive) {
      if (responseData?.timedModeActive || autotimer === true) {
        // Countdown Timer — functional update avoids adding timeLeft to deps,
        // which previously caused the interval to be torn down and recreated
        // every second, making the timer run slightly slower than real time.
        timerInterval = setInterval(() => {
          setTimeLeft((prevTimeLeft) => {
            if (prevTimeLeft === null) return prevTimeLeft;
            if (prevTimeLeft <= 1) {
              clearInterval(timerInterval);
              toast.error("Time's Up!");
              handleSubmit();
              return 0;
            }
            return prevTimeLeft - 1;
          });
        }, 1000);
      } else {
        // Stopwatch Timer
        timerInterval = setInterval(() => {
          setTimeLeft((prevTimeLeft) => (prevTimeLeft === null ? 0 : prevTimeLeft + 1));
        }, 1000);
      }
    }

    return () => clearInterval(timerInterval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timerActive, responseData?.timedModeActive, autotimer, user?.role]);

  // test_id가 바뀔 때마다 sessionStorage에 저장 (F5 복구용)
  useEffect(() => {
    if (test_id) sessionStorage.setItem('activeTestId', test_id);
  }, [test_id]);

  // 퀴즈 진행 중 F5/탭 닫기 경고
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isSubmittingRef.current) return;
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);


  const autosaveData = async () => {

    const now = new Date();
    const formattedDate = now.toISOString().slice(0, 19).replace('T', ' ');

    const qanswers = questions?.map(question => question.selectedOption);
    const qrealanswers = questions?.map(question => question.correct_answer);
    const qskillsets = questions?.map(question => question.primary_class_cd_descs);
    const qbookmarks = questions?.map(question => question.bookMarked);
    const qids = questions?.map(question => question.questionIds);
    const mode = currentQuestion?.section;

    let quiz = responseData?.type || 'SAT';

    // Determine the time value based on the mode
    let totalTimeSpent;
    totalTimeSpent = timeLeft;

    const hwClass = localStorage.getItem('hw_classname') || '';
    const hwTestname = localStorage.getItem('testname') || '';
    const saveName = localStorage.getItem('hw') === 'true' && hwClass
      ? `${hwClass} - ${hwTestname}`
      : `${quiz} Quiz`;

    if (user) {
      const data = {
        id: quiz,
        user_id: user.u_id,
        questions: qids,
        questionIds: currentQuestion?.questionIds,
        timeLeft: totalTimeSpent, // Save either time left or elapsed time correctly
        qanswers: qanswers,
        qbookmarks: qbookmarks,
        test_id: test_id,
        date: formattedDate,
        type: 'QUIZ',
        name: saveName,
        tutormode: responseData?.tutorModeActive || autotutor,
        timedMode: responseData?.timedModeActive || autotimer,
        tutorasked: askedConfirmation,
        result: result,
        qrealanswers: qrealanswers,
        qskillsets: qskillsets,
        mode: mode,
        original_tid: original_tid
      };

      try {
        await axios.post(BASELINE + "autosave", { params: { data: JSON.stringify(data) } });
      } catch (err) {
        console.error("Error during autosave:", err.message);
      }
    }
  };

  useEffect(() => {
    // Function to fetch initial data based on the current question
    const fetchInitialData = async () => {
      try {
        const response = await axios.post(
          BASELINE + 'whiteboard/search/by/qid',
          { qid: currentQuestion?.questionIds }
        );

        const newNotes = response.data.data.filter(
          (note) => note.shared === "true" && note.stat === "complete" && note.question_id === currentQuestion.questionIds
        );

        const newNotes2 = response.data.data.filter(
          (note) => note.test_id === test_id && note.stat === "writing" && note.question_id === currentQuestion.questionIds && note.user_id !== user.u_id
        );

        const newNotes3 = response.data.data.filter(
          (note) => note.test_id === test_id && note.stat === "writing" && note.question_id === currentQuestion.questionIds && note.user_id === user.u_id
        );

        const newNotes5 = response.data.data.filter(
          (note) => note.shared === "false" && note.stat === "complete" && note.question_id === currentQuestion.questionIds && note.user_id === user.u_id
        );



        setsavednotes(newNotes5);
        setrewritenotes(newNotes3);
        setprivatenotes(newNotes2);
        setpublicnotes(newNotes);  // Directly set to newNotes, replacing old notes
      } catch (error) {
        console.error('Error fetching initial data:', error);
      }
    };

    // Conditionally call fetchInitialData based on certain conditions

    if (((disablesave !== false) || (user?.role === 'teacher')) && !blitzModeActive) {
      autosaveData();
    }

    fetchInitialData();  // Fetch new data every time dependencies change
  }, [disablesave, currentQuestion, user, questions, test_id, timeLeft]);  // Dependencies array


  useEffect(() => {
    const script2 = document.createElement('script');
    script2.src = 'https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/contrib/auto-render.min.js';
    script2.integrity = 'sha384-+VBxd3r6XgURycqtZ117nYw44OOcIax56Z4dCRWbxyPt0Koah1uHoK0o4+/RRE05';
    script2.crossOrigin = 'anonymous';

    script2.onload = () => {
      if (boxItemLeftRef.current) {
        const options = {
          delimiters: [
            { left: '$$', right: '$$', display: false },
            { left: "$", right: "$", display: false },
            { left: '\\(', right: '\\)', display: false },
            { left: '\\[', right: '\\]', display: true },
            { left: '\\begin{array}', right: '\\end{array}', display: true }
          ],
          throwOnError: false,
        };
        window.renderMathInElement(boxItemLeftRef.current, options);
      }
    };
    document.body.appendChild(script2);
    return () => {
      document.body.removeChild(script2);
    };
  }, [showanswer]);

  useEffect(() => {
    setLoadingQuestions(false);
  }, [c]);

  const handleModalSubmit = () => {
    if (username.length !== 0) {
      setc(true);
      setIsModalOpen(false); // Close the modal after submission
    } else {
      alert("Please enter the name");
    }
  };

  useEffect(() => {
    let timerId;
    if (currentQuestion && result[currentQuestion.index] === undefined) {
      timerId = setInterval(() => {
        setQuestionTimers(prevTimers => {
          const newTimers = [...prevTimers];
          if (newTimers[currentQuestion.index] === undefined) {
            newTimers[currentQuestion.index] = 0;
          }
          newTimers[currentQuestion.index] += 1;
          return newTimers;
        });
      }, 1000); // Update every second
    }

    return () => clearInterval(timerId); // Clear interval when question changes or component unmounts
  }, [currentQuestion, result]);

  useEffect(() => {
    const currentTest = localStorage.getItem('currentTest');
    const runLocalStorageFlow = async () => {
      if (currentTest) {
        await handleLocalStorageData(currentTest); // Wait for handleLocalStorageData to finish
      } else {
        if (responseData) {
          if (responseData.test_id) {
            settest_id(responseData.test_id);
          } else {
            settest_id(uuidv4());
          }

          // Check if rank is true and show modal
          if (responseData.rank) {
            setLoadingQuestions(true);
            setIsModalOpen(true); // Show the modal when rank is true
          }

          if (responseData.timedModeActive === true) {
            // Setup countdown timer
            startCountdownTimer(responseData.timeLimit * 60);
          } else {
            // If not timed mode, start stopwatch
            startStopwatch(0);
          }

          setquestionsarr(responseData.questionIds);
        } else {
          const navType = performance.getEntriesByType?.('navigation')?.[0]?.type;
          const sessionTestId = sessionStorage.getItem('activeTestId');
          if (navType !== 'navigate' && sessionTestId) {
            handleSessionResume(sessionTestId);
          } else {
            getQuestions();
            setdisablesave(false);
          }
        }
      }
    };

    runLocalStorageFlow(); // Run the local storage flow on component mount

    // Clean up interval on component unmount to avoid memory leaks
    return () => {
      stopTimer(); // Function to stop and clear any active timers
    };
  }, [responseData]);

  useEffect(() => {
    setShowOptions(false);
  }, [currentQuestion?.questionIds]);

  useEffect(() => {
    const currentTest = localStorage.getItem('currentTest');

    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        setShowOptions(false);
      }
    };

    // ESC 키 이벤트 등록
    document.addEventListener('keydown', handleEsc);

    // currentTest 유무에 따라 처리
    if (currentTest) {
      handleLocalStorageData(currentTest).then(() => {
        if (responseData && responseData.timedModeActive === true) {
          startCountdownTimer(responseData.timeLimit * 60);
        } else if (responseData && responseData.timedModeActive === false) {
          startStopwatch(0);
        }
      });
    } else {
      if (responseData) {
        if (responseData.timedModeActive) {
          startCountdownTimer(responseData.timeLimit * 60);
        } else {
          startStopwatch(0);
        }
        setquestionsarr(responseData.questionIds);
      } else {
        const navType = performance.getEntriesByType?.('navigation')?.[0]?.type;
        const sessionTestId = sessionStorage.getItem('activeTestId');
        if (navType !== 'navigate' && sessionTestId) {
          handleSessionResume(sessionTestId);
        } else {
          getQuestions();
        }
      }
    }

    // 컴포넌트 언마운트 시 이벤트와 타이머 정리
    return () => {
      document.removeEventListener('keydown', handleEsc);
      stopTimer();
    };
  }, []);


  async function handleLocalStorageData(currentTest) {
    if (initRef.current) return;
    initRef.current = true;
    if (user.role === 'teacher') {
      settest_id(currentTest);
    } else {
      if (localStorage.getItem('hw') === 'true' && localStorage.getItem('original_text')) {
        settest_id(currentTest);
        setoriginal_tid(localStorage.getItem('original_text'));
      } else if (localStorage.getItem('diagnostic') === 'true') {
        settest_id(uuidv4());
      } else if (localStorage.getItem('hw') === 'true') {
        settest_id(uuidv4());
        setoriginal_tid(currentTest);
      } else {
        settest_id(currentTest);
      }
    }
    setdisablesave(false);
    try {
      const response = await axios.get(BASELINE + 'getautosavebytid', { params: { tid: currentTest } });
      const savedData = response.data.data[0];
      if (savedData) {
        let res;
        let jsonsetting = JSON.parse(savedData.Setting);
        let jsondata = JSON.parse(savedData.quiz_data);
        let qrr = jsondata.questions;
        setqarr(qrr);
        setautotutor(jsonsetting.tutormode);
        setAskedConfirmation(jsonsetting.tutorasked);
        setResult(jsonsetting.result);

        // Fetch questions based on the type of test
        if (savedData.type === 'SAT89') {
          setsutotpye('SAT89');
          res = await axios.get(BASELINE + "questions/sat89", { params: { id: qrr } });
        } else if (savedData.type === 'SAT10') {
          setsutotpye('SAT10');
          res = await axios.get(BASELINE + "questions/sat10", { params: { id: qrr } });
        } else {
          setsutotpye('SAT');
          res = await axios.get(BASELINE + "questions/sat", { params: { id: qrr } });
        }

        // Map the questions and prepare the state for displaying them
        let mappedQuestions = res.data.map((question, idx) => ({
          ...question,
          index: idx,
          answered: false,
          selectedOption: jsondata.qanswers[idx] || null,
          bookMarked: jsondata.qbookmarks[idx] || false,
          crossedOutOptions: [],
        }));
        setQuestions(mappedQuestions);

        // Restore the timer correctly based on the mode
        if (jsonsetting.timedMode === true) {
          setautotimer(true);
          startCountdownTimer(jsonsetting.timeLeft); // Start countdown timer
        } else {
          startStopwatch(jsonsetting.timeLeft); // Start stopwatch from the restored time
        }

        // For a new homework attempt (student loads teacher's test), always start at Q1.
        // Only restore saved position when resuming the student's own autosave (original_text is set).
        const isNewHomework = localStorage.getItem('hw') === 'true' && !localStorage.getItem('original_text');
        if (isNewHomework) {
          setCurrentQuestion(mappedQuestions[0]);
        } else {
          const questionIndex = jsondata.questions.findIndex(question => question === savedData.questionIds);
          setCurrentQuestion(mappedQuestions[questionIndex >= 0 ? questionIndex : 0]);
        }

        // Remove localStorage item after a delay
        setTimeout(() => {
          setdisablesave(true);
          setLoadingQuestions(false);
          localStorage.removeItem('currentTest');
        }, 2000);
      }

    } catch (error) {
      console.error("Error fetching autosave data:", error);
    }
  }

  // F5 새로고침 시 sessionStorage의 test_id로 기존 세션 복구
  async function handleSessionResume(sessionTestId) {
    if (initRef.current) return;
    initRef.current = true;
    settest_id(sessionTestId);
    setdisablesave(false);
    try {
      const response = await axios.get(BASELINE + 'getautosavebytid', { params: { tid: sessionTestId } });
      const savedData = response.data.data[0];
      if (!savedData) {
        // autosave not found — session expired; send user back rather than creating a duplicate test
        sessionStorage.removeItem('activeTestId');
        navigate(-1);
        return;
      }

      let jsonsetting = JSON.parse(savedData.Setting);
      let jsondata = JSON.parse(savedData.quiz_data);
      let qrr = jsondata.questions;
      setqarr(qrr);
      setautotutor(jsonsetting.tutormode);
      setAskedConfirmation(jsonsetting.tutorasked);
      setResult(jsonsetting.result);

      let res;
      if (savedData.type === 'SAT89') {
        setsutotpye('SAT89');
        res = await axios.get(BASELINE + "questions/sat89", { params: { id: qrr } });
      } else if (savedData.type === 'SAT10') {
        setsutotpye('SAT10');
        res = await axios.get(BASELINE + "questions/sat10", { params: { id: qrr } });
      } else {
        setsutotpye('SAT');
        res = await axios.get(BASELINE + "questions/sat", { params: { id: qrr } });
      }

      let mappedQuestions = res.data.map((question, idx) => ({
        ...question,
        index: idx,
        answered: false,
        selectedOption: jsondata.qanswers[idx] || null,
        bookMarked: jsondata.qbookmarks[idx] || false,
        crossedOutOptions: [],
      }));
      setQuestions(mappedQuestions);

      if (jsonsetting.timedMode === true) {
        setautotimer(true);
        startCountdownTimer(jsonsetting.timeLeft);
      } else {
        startStopwatch(jsonsetting.timeLeft);
      }

      const questionIndex = jsondata.questions.findIndex(q => q === savedData.questionIds);
      if (questionIndex >= 0) {
        setCurrentQuestion(mappedQuestions[questionIndex]);
      }

      setTimeout(() => {
        setdisablesave(true);
        setLoadingQuestions(false);
      }, 2000);
    } catch (error) {
      console.error("Error resuming session from sessionStorage:", error);
      sessionStorage.removeItem('activeTestId');
      navigate(-1);
    }
  }

  const startCountdownTimer = (startingTime) => {
    if (startingTime > 0) {
      startTimer(startingTime); // Start countdown timer from the given starting time
    }
  };

  const startStopwatch = (startingTime) => {
    startTimer(startingTime); // Start stopwatch from the given starting time
  };

  const startTimer = (initialTime) => {
    setTimeLeft(initialTime);
    setTimerActive(true);
  };

  const stopTimer = () => {
    setTimerActive(false);
    setTimeLeft(0);
    reset(); // Reset the stopwatch if needed
  };

  useEffect(() => {
    if (responseData?.timedModeActive) {
      startCountdownTimer(responseData.timeLimit * 60); // Start timer from saved time (in seconds)
    } else {
      start(); // Start stopwatch if untimed mode
    }
  }, [responseData, start]);

  async function handleSubmit() {
    try {
      let obtainedMarks = 0;
      let newDat = questions.map((question) => {
        var correctAnswer;

        if (question.correct_answer) {
          // Parse the string into a JSON array
          correctAnswer = JSON.parse(question.correct_answer);

          // If there's only one element, convert it to lowercase
          if (correctAnswer.length === 1) {
            correctAnswer = [correctAnswer[0].toLowerCase()];
          }
        } else {
          correctAnswer = ["No Answer"];
        }

        let isCorrect = false;
        if (Array.isArray(correctAnswer)) {
          for (let i = 0; i < correctAnswer.length; i++) {
            if (String(question.selectedOption).trim() === String(correctAnswer[i]).trim()) {
              isCorrect = true;
              break;
            }
          }
        } else {
          isCorrect = question.selectedOption === correctAnswer;
        }

        if (isCorrect) {
          obtainedMarks++;
          question.correct = true;
        } else {
          question.correct = false;
        }

        const bookMarked = question.bookMarked;
        const difficultys = question.difficultys;
        var type = responseData?.type || 'SAT'
        return {
          difficultys: difficultys,
          bookMarked: bookMarked,
          correct: question.correct,
          selectedOption: question.selectedOption,
          answered: question.answered,
          questionIds: question.questionIds,
          tag: question.tag,
          topic: question.skill_descs,
          correctAnswer: question.correct_answer,
          type: type
        }
      });

      var test_name;
      const testNames = {
        "SAT": "SAT Practice Quiz",
        "SAT89": "SAT89 Practice Quiz",
        "SAT10": "NMSQT Practice Quiz"
      };

      if (localStorage.getItem('diagnostic') === 'true') {
        test_name = localStorage.getItem('testname');
      } else {
        if (location && location.state) {
          const testType = responseData?.type || 'SAT';
          test_name = testNames[testType];
        } else {
          test_name = localStorage.testname;
        }
      }
      if (!test_name) {
        test_name = "SAT Practice Test";  // Set custom name if test_name is empty
      }

      const correctQuestions = newDat.filter(question => question.correct === true);
      const incorrectQuestions = newDat.filter(question => question.correct === false);
      const bookmarkedQuestions = newDat.filter(question => question.bookMarked === true); // Assuming 'bookMarked' exists
      const nullCorrectAnswerQuestions = newDat.filter(question => question.selectedOption === null);

      let data
      if (!user) {
        if (c) {
          const formattedTime = `${String(displayMinutes).padStart(2, '0')}:${String(displaySeconds).padStart(2, '0')}`;
          data = {
            Quiz_score: newDat,
            timeframe: formattedTime,
            userId: "Free user",
            username: username,
            test_name: "Free User Test",
            ori_id: "Free User Test",
            type: 'SAT',
            test_id: test_id,
            correctQuestions: correctQuestions,
            incorrectQuestions: incorrectQuestions,
            bookmarkedQuestions: bookmarkedQuestions,
            nullCorrectAnswerQuestions: nullCorrectAnswerQuestions,
            rank: true,
          }
        } else {
          data = {
            Quiz_score: newDat,
            timeframe: "",
            userId: "Free user",
            username: "Free user",
            test_name: "Free User Test",
            ori_id: "Free User Test",
            type: 'SAT',
            test_id: test_id,
            correctQuestions: correctQuestions,
            incorrectQuestions: incorrectQuestions,
            bookmarkedQuestions: bookmarkedQuestions,
            nullCorrectAnswerQuestions: nullCorrectAnswerQuestions
          }
        }
      } else {
        if (autotype.length === 0) {
          data = {
            Quiz_score: newDat,//all qu
            timeframe: timeLeft,
            userId: user.u_id,
            username: user.first_name + " " + user.last_name,
            test_name: test_name,
            ori_id: original_tid, //can be null
            type: responseData?.type || 'SAT',
            test_id: test_id,
            correctQuestions: correctQuestions,
            incorrectQuestions: incorrectQuestions,
            bookmarkedQuestions: bookmarkedQuestions,
            nullCorrectAnswerQuestions: nullCorrectAnswerQuestions
          }
        } else {
          data = {
            Quiz_score: newDat,//all qu
            timeframe: timeLeft,
            userId: user.u_id,
            username: user.first_name + " " + user.last_name,
            test_name: localStorage.getItem('hw') === 'true'
              ? `${localStorage.getItem('hw_classname') || ''} - ${localStorage.getItem('testname') || autotype}`
              : autotype + " Practice Test Report Card",
            ori_id: original_tid, //can be null
            type: autotype,
            test_id: test_id,
            correctQuestions: correctQuestions,
            incorrectQuestions: incorrectQuestions,
            bookmarkedQuestions: bookmarkedQuestions,
            nullCorrectAnswerQuestions: nullCorrectAnswerQuestions
          }
        }
      }

      localStorage.removeItem('currentTest');
      localStorage.removeItem('testname');
      localStorage.removeItem('type');
      localStorage.removeItem('hw');
      localStorage.removeItem('hw_classname');
      localStorage.removeItem('original_text');
      let saveResult = await axios.post(BASELINE + "tests/quiz", data);

      let saveResult2 = await axios.post(BASELINE + "removeautosavequiz", { data: { test_id: test_id, user_id: user.u_id } });

      isSubmittingRef.current = true;
      sessionStorage.removeItem('activeTestId');
      navigate(`/results/sat/quiz/${test_id}`);

    } catch (err) {
      toast.error(err.message);
    }


  }

  useEffect(() => {
    var elt = document.getElementById('calculator');
    var calculator = window.Desmos?.GraphingCalculator(elt, {
      graphpaper: true,
      keypad: true
    });
    return () => {
      calculator?.destroy();
    }
  }, [showCalculator])

  const handleBookMark = (itemId) => {
    setQuestions((pre => {
      return pre.map((question) => {
        if (question?.questionIds === itemId) {
          if (question.bookMarked) {
            return { ...question, bookMarked: false };
          } else {
            return { ...question, bookMarked: true };
          }
        } else {
          return question;
        }
      })
    }))
  }

  useEffect(() => {
    if (questions.length > 0 && currentQuestion) {
      let q = questions.find((ques => ques?.questionIds === currentQuestion?.questionIds));
      setCurrentQuestion(q);
    }
    if (auto === false) {
      setAskedConfirmation(questions.map(() => false));
    }
  }, [questions]);

  async function handleSelectOption(itemId, option) {
    setQuestions(prev => {
      const updatedQuestions = prev.map(question => {
        if (question.questionIds === itemId) {
          return { ...question, selectedOption: option };
        } else {
          return question;
        }
      });

      // Find the updated question and update the currentQuestion state
      const updatedQuestion = updatedQuestions.find(question => question.questionIds === itemId);
      setCurrentQuestion(updatedQuestion);

      return updatedQuestions;
    });

    // Optionally reset the confirmation state if the user selects an option after confirming
    setAskedConfirmation(prev => {
      const newAsked = [...prev];
      newAsked[currentQuestion.index] = false; // Reset if needed
      return newAsked;
    });
  }



  async function handleCrossOutOptions(itemId, option) {
    setQuestions((pre => {
      return pre.map((question) => {
        if (question?.questionIds == itemId) {
          let crossedOutOptions = question.crossedOutOptions;
          if (crossedOutOptions.includes(option)) {
            crossedOutOptions = crossedOutOptions.filter((el) => el !== option);
          } else {
            crossedOutOptions.push(option);
          }
          return { ...question, crossedOutOptions: crossedOutOptions };
        } else {
          return question;
        }
      })
    }))
  }

  const handleAnswerValueChange = (itemId, value) => {
    setQuestions(prevQuestions =>
      prevQuestions.map(question =>
        question.questionIds === itemId ? { ...question, selectedOption: value } : question
      )
    );
  };

  async function getQuestions() {
    if (auto === false) {
      try {
        setLoadingQuestions(true);
        let globalIndex = 0;
        let allQuestions = [];
        if (location && location.state && Array.isArray(location.state.modules)) {
          for (let module of location.state.modules) {
            let mappedVals = module.topics;

            var res;
            if (module.mmtmode !== true) {
              if (module.test === "SAT") {
                res = await axios.get(BASELINE + "questions/ppsat", { params: { section: module.selectedSection, subject: module.subject, difficulty: module.difficulty, topics: mappedVals, limit: module.questionLimit } });
              } else if (module.test === "SAT89") {
                res = await axios.get(BASELINE + "questions/ppsat89", { params: { section: module.selectedSection, subject: module.subject, difficulty: module.difficulty, topics: mappedVals, limit: module.questionLimit } });
              }
              else if (module.test === "SAT10") {
                res = await axios.get(BASELINE + "questions/ppsat10", { params: { section: module.selectedSection, subject: module.subject, difficulty: module.difficulty, topics: mappedVals, limit: module.questionLimit } });
              }
            } else {
              res = await axios.get(BASELINE + "questions/mmt", { params: { section: module.selectedSection, subject: module.subject, difficulty: module.difficulty, topics: mappedVals, limit: module.questionLimit } });
            }
            if (res.data.length < 1) {
              toast.error("Questions With these topics not found. Try other topics for now by going back")
            } else {
              start();
            }

            let mappedQuestions = res.data.map((question) => {
              return {
                ...question,
                index: globalIndex++,
                answered: false,
                bookMarked: false,
                crossedOutOptions: [],
                selectedOption: null,
                section: module.selectedSection
              };
            })

            allQuestions = [...allQuestions, ...mappedQuestions];
          }
        } else {
          console.warn('location.state.modules is not iterable');
        }
        setQuestions(allQuestions);
        setCurrentQuestion(allQuestions[0]);
        setAskedConfirmation(allQuestions.map(() => false));

        // Immediately persist an autosave so back→forward resumes this test
        // instead of calling getQuestions() again and creating a duplicate.
        if (user) {
          try {
            const now = new Date();
            const quiz = responseData?.type || 'SAT';
            await axios.post(BASELINE + "autosave", {
              params: {
                data: JSON.stringify({
                  id: quiz,
                  user_id: user.u_id,
                  questions: allQuestions.map(q => q.questionIds),
                  questionIds: allQuestions[0]?.questionIds,
                  timeLeft: 0,
                  qanswers: allQuestions.map(() => null),
                  qbookmarks: allQuestions.map(() => false),
                  test_id: test_id,
                  date: now.toISOString().slice(0, 19).replace('T', ' '),
                  type: 'QUIZ',
                  name: (() => {
                    const c = localStorage.getItem('hw_classname') || '';
                    const t = localStorage.getItem('testname') || '';
                    return localStorage.getItem('hw') === 'true' && c ? `${c} - ${t}` : `${quiz} Quiz`;
                  })(),
                  tutormode: false,
                  timedMode: responseData?.timedModeActive || false,
                  tutorasked: allQuestions.map(() => false),
                  result: [],
                  qrealanswers: allQuestions.map(q => q.correct_answer),
                  qskillsets: allQuestions.map(q => q.primary_class_cd_descs),
                  mode: allQuestions[0]?.section,
                  original_tid: original_tid,
                }),
              },
            });
          } catch (e) {
            console.error("Initial autosave failed:", e.message);
          }
        }

        if (responseData?.rank) {
          if (c) {
            setLoadingQuestions(false);
          }
        } else {
          setLoadingQuestions(false);
        }

      } catch (err) {
        setLoadingQuestions(false);
        toast.error(err.message);
      }
    }
  }

  useEffect(() => {

    setLoadingQuestions(true);
    let globalIndex = 0;
    let allQuestions = [];

    const fetchData = async () => {
      try {
        var res;
        if (responseData.type === 'SAT') {
          res = await axios.get(`${BASELINE}questions/sat`, {
            params: {
              id: questionsarr,
              section: responseData.tag
            }
          });
        }
        else if (responseData.type === 'SAT10' || responseData.type === 'NMSQT') {
          res = await axios.get(`${BASELINE}questions/sat10`, {
            params: {
              id: questionsarr,
              section: responseData.tag
            }
          });
        }
        else if (responseData.type === 'SAT89') {
          res = await axios.get(`${BASELINE}questions/sat89`, {
            params: {
              id: questionsarr,
              section: responseData.tag
            }
          });
        }

        if (res.data.length < 1) {
          toast.error("Questions With these topics not found. Try other topics for now by going back")
        } else {
          start();
        }

        let mappedQuestions = res.data.map((question) => {
          return {
            ...question,
            index: globalIndex++,
            answered: false,
            bookMarked: false,
            crossedOutOptions: [],
            selectedOption: null,
            section: responseData.tag
          };
        })

        allQuestions = [...allQuestions, ...mappedQuestions];

        setQuestions(allQuestions);
        setCurrentQuestion(allQuestions[0]);
        if (responseData?.rank) {
          if (c) {
            setLoadingQuestions(false);
          }
        } else {
          setLoadingQuestions(false);
        }
      } catch (error) {
        console.error('Failed to fetch data:', error);
        // Handle errors if needed
      }
    };

    if (questionsarr.length > 0) {
      fetchData();
      setResult(new Array(questionsarr.length).fill(undefined));
    }
  }, [questionsarr]);  // Include responseData.tag in the dependency array if it's expected to change

  function checkAnswer(userInput, correctAnswersJSON) {
    // Parse the correct answers JSON and normalize
    const correctAnswers = JSON.parse(correctAnswersJSON).map(answer => {
      // Normalize each answer: handle numbers and fractions
      if (typeof answer === 'string' && answer.includes('/')) {
        return parseFraction(answer);  // Handle fractions
      } else if (!isNaN(answer)) {
        // Handle integers and floats
        return parseFloat(answer);
      }
      return answer.toString().toLowerCase(); // Handle string answers (e.g., 'A', 'B', etc.)
    });

    // Normalize user input for both numbers and strings
    let normalizedInput;
    if (typeof userInput === 'string' && userInput.includes('/')) {
      normalizedInput = parseFraction(userInput);  // Handle fraction input
    } else if (!isNaN(userInput)) {
      normalizedInput = parseFloat(userInput);  // Handle number input
    } else {
      normalizedInput = userInput.toString().toLowerCase();  // Handle string input (e.g., 'A', 'B', etc.)
    }

    // Check if the normalized user input is in the list of correct answers
    return correctAnswers.includes(normalizedInput);
  }

  function parseFraction(fraction) {
    let [numerator, denominator] = fraction.split('/');
    return denominator ? parseFloat(numerator) / parseFloat(denominator) : parseFloat(numerator);
  }

  const handleNext = async () => {
    // 스크롤을 맨 위로 이동
    const mainContent = document.querySelector('.flex-1.overflow-y-auto');
    if (mainContent) {
      mainContent.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }

    setshowanswer(false);
    // Treat tutorModeActive as false if it's not defined
    const tutorModeActive = responseData?.tutorModeActive || autotutor;

    if (!tutorModeActive) {
      if (currentQuestion.index < questions.length - 1) {
        setCurrentQuestion((prev) => questions[prev.index + 1]);
      } else {
        setCurrentQuestion(null);
        setQuestionOverviewOpen(false);
      }
    } else {
      const currentIdx = currentQuestion.index;

      if (currentQuestion.selectedOption !== null) {
        // 이미 평가된 문제(result 있음)이거나 이미 확인한 경우 → 확인창 스킵
        const alreadyEvaluated = result[currentIdx] !== undefined;
        if (!askedConfirmation[currentIdx] && !alreadyEvaluated) {
          const userResponse = window.confirm(
            "Are you sure you want to proceed?"
          );
          if (!userResponse) {
            return;
          }
          setAskedConfirmation(prev => {
            const newAsked = [...prev];
            newAsked[currentIdx] = true;
            return newAsked;
          });
        }

        // Check if the selected option is correct
        const isCorrect = checkAnswer(
          currentQuestion.selectedOption,
          currentQuestion.correct_answer
        );
        // Update the result array at the current question's index
        setResult((prevResults) => {
          const newResults = [...prevResults];
          newResults[currentQuestion.index] = isCorrect;
          return newResults;
        });

        // Use the updated result (since setState is async)
        setTimeout(() => {
          if (result[currentIdx] !== undefined) {
            if (currentQuestion.index < questions.length - 1) {
              setCurrentQuestion(questions[currentQuestion.index + 1]);
            } else {
              setCurrentQuestion(null);
              setQuestionOverviewOpen(false);
            }
          }
        }, 0);
      } else {
        if (currentQuestion.index < questions.length - 1) {
          setCurrentQuestion((prev) => questions[prev.index + 1]);
        } else {
          setCurrentQuestion(null);
          setQuestionOverviewOpen(false);
        }
      }
    }
  };

  const handleNextRef = useRef(null);
  useEffect(() => { handleNextRef.current = handleNext; });

  useEffect(() => {
    if (!blitzModeActive || !currentQuestion) {
      if (blitzIntervalRef.current) clearInterval(blitzIntervalRef.current);
      setBlitzQuestionTimeLeft(null);
      return;
    }

    setBlitzQuestionTimeLeft(blitzTimeLimit);
    if (blitzIntervalRef.current) clearInterval(blitzIntervalRef.current);

    // Teachers review questions — don't auto-advance or count down
    if (user?.role === 'teacher') return;

    blitzIntervalRef.current = setInterval(() => {
      setBlitzQuestionTimeLeft(prev => {
        if (prev === null) return null;
        if (prev <= 1) {
          clearInterval(blitzIntervalRef.current);
          setTimeout(() => handleNextRef.current?.(), 50);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      if (blitzIntervalRef.current) clearInterval(blitzIntervalRef.current);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentQuestion?.questionIds, blitzModeActive, blitzTimeLimit, user?.role]);

  async function handleBack() {
    if (!currentQuestion) {
      setCurrentQuestion(questions[questions.length - 1]);
      return;
    }
    if (currentQuestion.index > 0) {
      setCurrentQuestion((pre) => questions[pre.index - 1])
    } else {

    }
  }

  const closeRefModal = () => {
    setShowDirectionRefModal(false);
  };

  const closeModal = () => {
    setShowDirectionModal(false);
  };

  const handleSave = async () => {
    const now = new Date();
    const formattedDate = now.toISOString().slice(0, 19).replace('T', ' ');

    const qanswers = questions?.map(question => question.selectedOption);
    const qrealanswers = questions?.map(question => question.correct_answer);
    const qskillsets = questions?.map(question => question.primary_class_cd_descs);
    const qbookmarks = questions?.map(question => question.bookMarked);
    const qids = questions?.map(question => question.questionIds);

    let quiz = responseData?.type || 'SAT';

    // Determine the time value based on the mode
    let totalTimeSpent;
    if (responseData?.timedModeActive) {
      // Save the remaining time in countdown mode
      totalTimeSpent = timeLeft;
    } else {
      totalTimeSpent = timeLeft;
    }

    const data = {
      id: quiz,
      user_id: user.u_id,
      premium: user.premium,
      questions: qids,
      questionIds: currentQuestion?.questionIds,
      timeLeft: totalTimeSpent, // Save either time left or elapsed time correctly
      qanswers: qanswers,
      qbookmarks: qbookmarks,
      test_id: test_id,
      date: formattedDate,
      type: 'QUIZ',
      name: `${quiz} Quiz`,
      tutormode: responseData?.tutorModeActive || autotutor,
      timedMode: responseData?.timedModeActive || autotimer,
      tutorasked: askedConfirmation,
      result: result,
      qrealanswers: qrealanswers,
      qskillsets: qskillsets,
      original_tid: original_tid
    };

    try {
      let res = await axios.post(BASELINE + "autosave", { params: { data: JSON.stringify(data) } });
      if (res.status === 200) {
        toast.success("Quiz Saved Successfully");
        navigate("/dashboard/teacher");
      } else {
        throw new Error("Unexpected response from the server.");
      }
    } catch (err) {
      if (err.response && err.response.status === 400) {
        toast.error(err.response.data.message || "Loading...");
      } else {
        toast.error(err.message || "An unexpected error occurred.");
      }
    }
  }

  const toggleHighlightMode = useCallback(() => {
    setHighlightMode(prev => {
      const next = !prev;
      document.cookie = `highlightMode=${next}; path=/; max-age=86400`;
      return next;
    });
  }, []);

  const handleShare = useCallback(async () => {
    if (!quizContentRef.current || !user?.u_id) return;
    setShowOptions(false);
    setIsSharing(true);
    try {
      const el = quizContentRef.current;
      // Capture the question DOM as-is (including any highlights) — same flags as existing toPng usage
      const dataUrl = await toPng(el, {
        backgroundColor: '#ffffff',
        skipFonts: true,
        pixelRatio: 2,
      });
      const res = await axios.post(BASELINE + 'share/question-image', {
        user_id: user.u_id,
        imageBase64: dataUrl,
      });
      if (res.data?.url) {
        try {
          await navigator.clipboard.writeText(res.data.url);
          toast.success('Share link copied to clipboard!', { duration: 4000 });
        } catch {
          // Clipboard API not available (e.g. http non-secure) — show the URL
          toast(res.data.url, { duration: 12000 });
        }
      }
    } catch (err) {
      console.error('Share failed:', err);
      toast.error('Failed to create share link. Please try again.');
    } finally {
      setIsSharing(false);
    }
  }, [user]);


  const applyHighlightByText = useCallback((container, text, questionId) => {
    if (!text || !container) return;
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null, false);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement?.tagName === 'MARK') continue;
      const idx = node.textContent.indexOf(text);
      if (idx === -1) continue;
      const range = document.createRange();
      range.setStart(node, idx);
      range.setEnd(node, idx + text.length);
      const mark = document.createElement('mark');
      mark.style.cssText = 'background-color:#fef08a;border-radius:3px;cursor:pointer;padding:0 1px;';
      mark.title = 'Click to remove highlight';
      mark.onclick = (e) => {
        const parent = mark.parentNode;
        while (mark.firstChild) parent.insertBefore(mark.firstChild, mark);
        parent.removeChild(mark);
        if (highlightsRef.current[questionId]) {
          const i = highlightsRef.current[questionId].indexOf(text);
          if (i !== -1) highlightsRef.current[questionId].splice(i, 1);
        }
        e.stopPropagation();
      };
      try { range.surroundContents(mark); } catch { /* single text-node range — should not fail */ }
      break;
    }
  }, []);

  const handleMouseUp = useCallback(() => {
    if (!highlightMode) return;
    const selection = window.getSelection();
    if (!selection || selection.isCollapsed || selection.rangeCount === 0) return;
    const selectedText = selection.toString().trim();
    if (!selectedText) return;
    const range = selection.getRangeAt(0);

    // Only allow highlights within designated highlightable zones (passage, stem, options).
    // This prevents selections that cross element boundaries or hit UI controls from
    // breaking the DOM via range.surroundContents / extractContents.
    const getHighlightZone = (node) => {
      let el = node.nodeType === Node.TEXT_NODE ? node.parentElement : node;
      while (el) {
        if (el.dataset?.highlightable === 'true') return el;
        el = el.parentElement;
      }
      return null;
    };
    const startZone = getHighlightZone(range.startContainer);
    const endZone = getHighlightZone(range.endContainer);
    if (!startZone || startZone !== endZone) {
      selection.removeAllRanges();
      return;
    }

    const questionId = currentQuestion?.questionIds;
    const mark = document.createElement('mark');
    mark.style.cssText = 'background-color:#fef08a;border-radius:3px;cursor:pointer;padding:0 1px;';
    mark.title = 'Click to remove highlight';
    mark.onclick = (e) => {
      const parent = mark.parentNode;
      while (mark.firstChild) parent.insertBefore(mark.firstChild, mark);
      parent.removeChild(mark);
      if (questionId && highlightsRef.current[questionId]) {
        const i = highlightsRef.current[questionId].indexOf(selectedText);
        if (i !== -1) highlightsRef.current[questionId].splice(i, 1);
      }
      e.stopPropagation();
    };

    try {
      range.surroundContents(mark);
      // Only save the text after the DOM highlight actually succeeded.
      selection.removeAllRanges();
      if (questionId) {
        if (!highlightsRef.current[questionId]) highlightsRef.current[questionId] = [];
        highlightsRef.current[questionId].push(selectedText);
      }
    } catch {
      // Selection spans element boundaries — abort without touching the DOM.
      selection.removeAllRanges();
    }
  }, [highlightMode, currentQuestion]);

  // Re-apply saved highlights when navigating back to a previously visited question
  useEffect(() => {
    const questionId = currentQuestion?.questionIds;
    if (!questionId || !quizContentRef.current) return;
    if (questionId === prevQuestionIdRef.current) return;
    prevQuestionIdRef.current = questionId;
    const stored = highlightsRef.current[questionId];
    if (!stored || stored.length === 0) return;
    const timer = setTimeout(() => {
      stored.forEach(text => applyHighlightByText(quizContentRef.current, text, questionId));
    }, 200);
    return () => clearTimeout(timer);
  }, [currentQuestion, applyHighlightByText]);

  const handleReportClick = useCallback(() => {
    setShowModal(true);
  }, []);

  const handleContextChange = (event) => {
    setContext(event.target.value);
  };

  const handleSubmit2 = () => {
    const questionId = currentQuestion.questionIds;
    const reportFrom = user.first_name + " " + user.last_name;

    var type;
    if (currentQuestion.programs === 'SAT') {
      type = 'SAT';
    } else if (currentQuestion.programs === 'P10') {
      type = 'SAT10';
    } else {
      type = 'SAT89';
    }

    var data = {
      questionId: questionId,
      name: reportFrom,
      context: context,
      type: type
    }

    axios.post(BASELINE + 'questions/report/note', [data])
      .then(response => {
        alert('Report submitted successfully!');
      })
      .catch(error => {
        console.error(error);
      });

    setContext('');
    setShowModal(false);
  };

  const handleCloseModal = () => {
    // Clear the context and close the modal
    setContext('');
    setShowModal(false);
  };

  async function askforhelp() {
    var data;
    if (currentQuestion.programs === 'SAT') {
      data = {
        questionidsarr: questionsarr,
        student_id: user.u_id,
        type: "SAT",
        tag: currentQuestion.tag,
        test_id: test_id
      };
    } else if (currentQuestion.programs === 'P10') {
      data = {
        questionidsarr: questionsarr,
        student_id: user.u_id,
        type: "NMSQT",
        tag: currentQuestion.tag,
        test_id: test_id
      };
    }
    else if (currentQuestion.programs === 'P89') {
      data = {
        questionidsarr: questionsarr,
        student_id: user.u_id,
        type: "SAT89",
        tag: currentQuestion.tag,
        test_id: test_id
      };
    }
    if (window.confirm("Are you sure you want to get help?")) {
      axios.post(BASELINE + 'post/question/set', [data])
        .then(response => {
          // Handle different responses based on status codes
          if (response.status === 201) {
            window.alert("If you have an assigned teacher, then the teacher will contact you.");
          } else if (response.status === 409) {
            window.alert("A help request with this test ID already exists.");
          } else {
            window.alert("Unexpected response from the server: " + response.status);
          }
        })
        .catch(error => {
          // Handle errors based on the status code returned from the server
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            const status = error.response.status;
            if (status === 409) {
              window.alert("A help request with this test ID already exists.");
            } else if (status === 500) {
              window.alert("Internal server error. Please try again later.");
            } else {
              window.alert("An error occurred: " + error.response.status);
            }
          } else if (error.request) {
            // The request was made but no response was received
            window.alert("No response from the server. Please check your network connection.");
          } else {
            window.alert("Error: " + error.message);
          }
        });
    } else {
      window.alert("Help request cancelled.");
    }
  }

  // 예시: status 매핑 (실제 로직에 맞게 변경 가능)
  // answered: lime / marked: blue / unanswered: brown / markedAndAnswered: green ...
  const questionStatus = {
    1: "answered",
    2: "unanswered",
    3: "answered",
    4: "unanswered",
    5: "marked",
    8: "markedAndAnswered",
    // 나머지는 기본 상태(unanswered 등)
  };

  // Tailwind에서 색상 클래스를 매핑
  const getStatusColor = (num) => {
    switch (questionStatus[num]) {
      case "answered":
        return "bg-lime-400 text-gray-800";
      case "marked":
        return "bg-blue-600 text-white";
      case "unanswered":
        return "bg-[#6A5949] text-white"; // 갈색 tones
      case "markedAndAnswered":
        return "bg-green-500 text-white";
      default:
        return "bg-[#3B3B3B] text-white"; // 기본 다크 그레이
    }
  };

  return (
    <div className="flex flex-col h-screen overflow-hidden bg-white">

      {/* Blitz Mode Alert Banner */}
      {blitzModeActive && (
        <div className="bg-orange-600 text-white text-[11px] font-semibold px-4 py-1.5 flex items-center justify-center gap-2 flex-shrink-0">
          <span>Blitz Mode — No auto-save · AI support disabled · Questions auto-advance when time runs out</span>
        </div>
      )}
      {/* Top Navigation Bar */}
      <div className={`flex justify-between items-center px-4 py-2 ${responseData?.help ? 'bg-slate-700' : 'bg-[#1a1a1a]'} text-white`}>
        <div className="flex items-center space-x-4">
          <h4 className="font-bold">
            {currentQuestion ? (
              responseData?.help !== true ? (
                <>
                  <span className="hidden sm:block">Quiz Module: {currentQuestion.section} {currentQuestion.programs}</span>
                  <span className="sm:hidden">Quiz</span>
                </>
              ) : (
                <span>Review Session</span>
              )
            ) : (
              <>
                <span className="sm:hidden">Review</span>
                <span className="hidden sm:block">Module Review</span>
              </>
            )}
          </h4>
        </div>

        <div className="flex items-center justify-center gap-2">
          {blitzModeActive ? (
            <div className="flex items-center gap-1.5 bg-orange-500/20 border border-orange-400/40 rounded-lg px-3 py-1">
              <span className={`font-mono font-bold text-base leading-none ${
                blitzQuestionTimeLeft !== null && blitzQuestionTimeLeft <= 5
                  ? 'text-red-400 animate-pulse'
                  : blitzQuestionTimeLeft !== null && blitzQuestionTimeLeft <= 10
                  ? 'text-orange-300'
                  : 'text-orange-200'
              }`}>
                {blitzQuestionTimeLeft ?? blitzTimeLimit}s
              </span>
              <span className="text-orange-400/70 text-[10px] font-semibold">/ Q</span>
            </div>
          ) : showTimer ? (
            <Timer
              minutes={displayMinutes.toString().padStart(2, '0')}
              seconds={displaySeconds.toString().padStart(2, '0')}
            />
          ) : (
            <span className="text-white/40 text-sm font-medium select-none">Hidden</span>
          )}
          {!blitzModeActive && (
            <button
              onClick={() => setShowTimer(prev => !prev)}
              className="text-white/40 hover:text-white/80 transition-colors"
              title={showTimer ? "Hide Timer" : "Show Timer"}
            >
              {showTimer ? <BsEyeSlash size="1em" /> : <BsEye size="1em" />}
            </button>
          )}
        </div>

        <div className="flex items-center space-x-2">
          {/* Highlight — always visible */}
          <motion.button
            whileTap={{ scale: 0.97 }}
            onClick={toggleHighlightMode}
            className={`p-2 flex flex-col items-center transition-colors duration-200 ${highlightMode ? 'text-yellow-300' : 'text-white/70 hover:text-white'}`}
          >
            <BsPencilFill size="1.2em" />
            <span className="text-xs hidden md:block">Highlight</span>
          </motion.button>

          {/* Notes — always visible */}
          <motion.button
            whileTap={{ scale: 0.97 }}
            onClick={() => setShowNotes(prev => !prev)}
            className={`p-2 flex flex-col items-center transition-colors duration-200 ${showNotes ? 'text-amber-300' : 'text-white/70 hover:text-white'}`}
          >
            <BsJournalText size="1.2em" />
            <span className="text-xs hidden md:block">Notes</span>
          </motion.button>

          {(currentQuestion?.tag === "math") && (
            <>
              <motion.button
                whileTap={{ scale: 0.97 }}
                onClick={() => setShowCalculator(prev => !prev)}
                className="p-2 hover:text-[#7cb0eb] flex flex-col items-center"
              >
                <CiCalculator1 size="1.5em" />
                <span className="text-xs hidden md:block">Calculator</span>
              </motion.button>

              <motion.button
                whileTap={{ scale: 0.97 }}
                onClick={() => setShowDirectionRefModal(!showDirectionModalRef)}
                className="hidden md:flex flex-col items-center justify-center p-2 hover:text-[#7cb0eb]"
              >
                <VscReferences size="1.5em" />
                <span className="text-xs">Reference</span>
              </motion.button>
            </>
          )}

          {showOptions && (
            <div
              className="fixed inset-0 z-[199]"
              onClick={() => setShowOptions(false)}
            />
          )}
          <div className="relative">
            <button
              onClick={() => setShowOptions(prev => !prev)}
              className={`p-2 flex flex-col items-center transition-colors duration-200 ${showOptions ? 'text-white' : 'text-white/70 hover:text-white'}`}
            >
              <BsThreeDotsVertical size="1.5em" />
              <span className="text-xs hidden md:block">More</span>
            </button>

            {showOptions && (
              <div className="absolute top-[calc(100%+8px)] right-0 z-[200] overflow-hidden bg-black/90 backdrop-blur-2xl border border-white/10 rounded-2xl shadow-2xl shadow-black/50 p-2 flex flex-col gap-1 min-w-[150px]">
                <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent pointer-events-none" />

                {/* Report */}
                {!blitzModeActive && (
                  <button
                    onClick={() => { handleReportClick(); setShowOptions(false); }}
                    disabled={!currentQuestion}
                    className={`flex items-center gap-2.5 px-3 py-2 rounded-xl text-sm font-medium transition-all duration-200 ${
                      currentQuestion
                        ? 'text-white/60 hover:text-rose-300 hover:bg-rose-500/10'
                        : 'text-white/20 cursor-not-allowed'
                    }`}
                  >
                    <BsExclamationTriangle className="text-xs flex-shrink-0" />
                    <span>Report</span>
                  </button>
                )}

                {/* Dashboard */}
                <button
                  onClick={() => { navigate("/main/sat"); }}
                  className="flex items-center gap-2.5 px-3 py-2 rounded-xl text-sm font-medium text-white/60 hover:text-blue-300 hover:bg-blue-500/10 transition-all duration-200"
                >
                  <MdDashboard className="text-xs flex-shrink-0" />
                  <span>Dashboard</span>
                </button>

                {/* Answer Key — teacher only */}
                {user?.role === 'teacher' && (
                  <button
                    onClick={() => { setshowanswer(prev => !prev); setShowOptions(false); }}
                    className={`flex items-center gap-2.5 px-3 py-2 rounded-xl text-sm font-medium transition-all duration-200 ${
                      showanswer
                        ? 'bg-blue-500/15 border border-blue-400/25 text-blue-300'
                        : 'text-white/60 hover:text-blue-300 hover:bg-blue-500/10'
                    }`}
                  >
                    <FaKey className="text-xs flex-shrink-0" />
                    <span>Answer Key</span>
                  </button>
                )}

                {/* Save — teacher only */}
                {user?.role === 'teacher' && (
                  <button
                    onClick={() => { handleSave(); setShowOptions(false); }}
                    className="flex items-center gap-2.5 px-3 py-2 rounded-xl text-sm font-medium text-white/60 hover:text-emerald-300 hover:bg-emerald-500/10 transition-all duration-200"
                  >
                    <AiOutlineSave className="text-xs flex-shrink-0" />
                    <span>Save</span>
                  </button>
                )}

                {/* Share — captures current question as image, uploads, copies link */}
                {currentQuestion && (
                  <button
                    onClick={handleShare}
                    disabled={isSharing}
                    className="flex items-center gap-2.5 px-3 py-2 rounded-xl text-sm font-medium text-white/60 hover:text-emerald-300 hover:bg-emerald-500/10 transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed"
                  >
                    <BsShare className="text-xs flex-shrink-0" />
                    <span>{isSharing ? 'Capturing…' : 'Share'}</span>
                  </button>
                )}

              </div>
            )}

            {showModal && (
              <div className="fixed z-50 inset-0 overflow-y-auto">
                <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-4 text-center sm:p-0">
                  {/* Overlay */}
                  <div className="fixed inset-0 transition-opacity" aria-hidden="true">
                    <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
                  </div>

                  {/* Modal Content */}
                  <div className="inline-block align-middle bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full max-w-lg mx-4">
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6">
                      <div className="sm:flex sm:items-start">
                        <div className="w-full text-center sm:text-left text-black">
                          <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4" id="modal-title">
                            Report Card
                          </h3>
                          <div className="mt-2 space-y-4">
                            <form className="space-y-4">
                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Question ID:</label>
                                <input
                                  type="text"
                                  className="border p-2 w-full rounded-md"
                                  value={currentQuestion.questionIds}
                                  readOnly
                                />
                              </div>

                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Report from:</label>
                                {user ? (
                                  <input
                                    type="text"
                                    className="border p-2 w-full rounded-md"
                                    value={user?.first_name + " " + user?.last_name}
                                    readOnly
                                  />
                                ) : (
                                  <input
                                    type="text"
                                    className="border p-2 w-full rounded-md"
                                    value="Thank you for the report"
                                    readOnly
                                  />
                                )}
                              </div>

                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Context:</label>
                                <textarea
                                  className="border p-2 w-full rounded-md min-h-[100px] resize-none"
                                  value={context}
                                  onChange={handleContextChange}
                                  placeholder="Please describe the issue..."
                                />
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse gap-2">
                      <button
                        type="button"
                        className="w-full sm:w-auto inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm transition-colors"
                        onClick={handleSubmit2}
                      >
                        Submit
                      </button>
                      <button
                        type="button"
                        className="mt-3 sm:mt-0 w-full sm:w-auto inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm transition-colors"
                        onClick={handleCloseModal}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex h-full overflow-hidden">
        {/* Question Overview Panel */}
        {(!blitzModeActive || user?.role === 'teacher') && (
          <div
            className={`
        transition-all duration-300
        ${questionOverViewOpen ? 'w-1/5' : 'w-0'}
        overflow-hidden
      `}
          >
            <QuestionOverview
              questionOverViewOpen={questionOverViewOpen}
              setQuestionOverviewOpen={setQuestionOverviewOpen}
              questions={questions}
              currentQuestion={currentQuestion}
              setCurrentQuestion={setCurrentQuestion}
              askedConfirmation={askedConfirmation}
            />
          </div>
        )}

        {/* Main Question Area */}
        <div
          className={`
      transition-all duration-300 flex flex-col overflow-hidden
      ${questionOverViewOpen
              ? showanswer
                ? 'w-3/5'
                : 'w-4/5'
              : showanswer
                ? 'w-4/5'
                : 'w-full'
            }
    `}
        >
          <div className="flex-1 overflow-y-auto scrollbar-hide">
            {loadingQuestions ? (
              <div className="flex justify-center items-center h-full">
                <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div>
              </div>
            ) : (
              currentQuestion ? (
                <div
                  ref={quizContentRef}
                  className="px-4 pt-4"
                  onMouseUp={handleMouseUp}
                  style={highlightMode ? { cursor: 'text', userSelect: 'text' } : {}}
                >
                  <Question
                    sat={currentQuestion.section || currentQuestion.tag}
                    handleAnswerValueChange={handleAnswerValueChange}
                    handleCrossOutOptions={handleCrossOutOptions}
                    handleSelectOption={handleSelectOption}
                    currentQuestion={currentQuestion}
                    idx={1}
                    bookmarkedQuestions={bookmarkedQuestions}
                    setBookMarkedQuestions={setBookMarkedQuestions}
                    handleBookMark={handleBookMark}
                    result={result[currentQuestion.index]}
                    time={questionTimers[currentQuestion.index]}
                    questionOverViewOpen={questionOverViewOpen}
                    hideBookmark={blitzModeActive}
                  />
                </div>
              ) : (
                <Review
                  currentQuestion={currentQuestion}
                  setCurrentQuestion={setCurrentQuestion}
                  questions={questions}
                  setQuestions={setQuestions}
                  questionTimers={questionTimers}
                  result={result}
                />
              )
            )}

            {currentQuestion && result.length > 0 &&
              !blitzModeActive &&
              (autotutor === true || responseData?.tutorModeActive === true) && (
                <AIAudioPlayer
                  result={result[currentQuestion?.index]}
                  context={aicontext}
                  currentQuestion={currentQuestion}
                  type1={responseData?.type}
                  type2={autotype}
                  isChatVisible={isChatVisible}
                  setIsChatVisible={setIsChatVisible}
                />
              )}

            {/* Notes Panel */}
            {showNotes && (
              <motion.div
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 16 }}
                transition={{ duration: 0.2 }}
                className="fixed bottom-0 left-0 sm:left-4 sm:bottom-4 w-full sm:w-[360px] z-[900] flex flex-col rounded-xl shadow-2xl overflow-hidden border border-white/10"
                style={{ background: '#1a1c24' }}
              >
                {/* Header */}
                <div className="flex items-center justify-between px-4 py-2.5 border-b border-white/10" style={{ background: '#22242e' }}>
                  <div className="flex items-center gap-2">
                    <BsJournalText className="text-amber-400 text-sm" />
                    <span className="text-white text-sm font-semibold">Notes</span>
                    <span className="text-white/30 text-[10px]">Session only</span>
                  </div>
                  <button
                    onClick={() => setShowNotes(false)}
                    className="text-white/40 hover:text-white text-lg leading-none transition-colors"
                  >
                    &times;
                  </button>
                </div>
                {/* Textarea */}
                <textarea
                  className="flex-1 resize-none bg-transparent text-white/80 placeholder-white/20 text-sm px-4 py-3 focus:outline-none"
                  style={{ minHeight: '220px', maxHeight: '320px' }}
                  placeholder="Write your notes here... (clears when session ends)"
                  value={notesText}
                  onChange={(e) => setNotesText(e.target.value)}
                  autoFocus
                />
                {/* Footer */}
                <div className="px-4 py-2 border-t border-white/10 flex justify-between items-center">
                  <span className="text-white/25 text-[11px]">{notesText.length} chars</span>
                  <button
                    onClick={() => setNotesText('')}
                    className="text-white/30 hover:text-rose-400 text-[11px] transition-colors"
                  >
                    Clear
                  </button>
                </div>
              </motion.div>
            )}
          </div>

          {/* PC */}
          <div className="hidden md:flex justify-between items-center px-6 py-4 bg-[#1a1a1a] text-white shadow-md">
            <div className="hidden md:block">
              <p className="font-medium text-gray-200">
                {c ? username : (user ? `${user.first_name} ${user.last_name}` : 'Free User')}
              </p>
            </div>

            {(!blitzModeActive || user?.role === 'teacher') && (
              <button
                onClick={() => setQuestionOverviewOpen(prev => !prev)}
                className="flex items-center space-x-2 bg-gray-700 hover:bg-gray-600 text-white px-5 py-2.5 rounded-md text-[14px] sm:text-[15px] transition-colors duration-200 border border-gray-600"
              >
                {currentQuestion ? (
                  <span className="font-medium">Question {currentQuestion?.index + 1} of {questions?.length}</span>
                ) : (
                  <span className="font-medium">Review Session</span>
                )}
                <span className="ml-2">
                  {questionOverViewOpen ? <BsChevronDown /> : <BsChevronUp />}
                </span>
              </button>
            )}

            {blitzModeActive && user?.role !== 'teacher' && currentQuestion && (
              <span className="text-white/40 text-sm font-medium">
                {currentQuestion.index + 1} / {questions.length}
              </span>
            )}

            <div className="flex space-x-3">
              {(!blitzModeActive || user?.role === 'teacher') && (
                <motion.button
                  whileTap={{ scale: 0.97 }}
                  onClick={handleBack}
                  className="px-5 py-2.5 rounded-md bg-gray-700 hover:bg-gray-600 text-white transition-colors duration-200 border border-gray-600 font-medium"
                >
                  Back
                </motion.button>
              )}

              {currentQuestion ? (
                (!blitzModeActive || user?.role === 'teacher' || currentQuestion.selectedOption !== null) && (
                  <motion.button
                    whileTap={{ scale: 0.97 }}
                    onClick={handleNext}
                    className="px-5 py-2.5 rounded-md bg-blue-600 hover:bg-blue-700 text-white transition-colors duration-200 shadow-md font-medium"
                  >
                    Next
                  </motion.button>
                )
              ) : (
                !loadingQuestions && responseData?.help !== true && !submitClicked && (
                  <motion.button
                    whileTap={{ scale: 0.97 }}
                    onClick={() => {
                      setSubmitClicked(true);
                      handleSubmit();
                    }}
                    className="px-5 py-2.5 rounded-md bg-gradient-to-r from-emerald-500 to-blue-500 hover:from-emerald-600 hover:to-blue-600 text-white transition-colors duration-200 shadow-md font-medium"
                  >
                    Submit
                  </motion.button>
                )
              )}
            </div>
          </div>

          {/* MOBILE */}
          <div className="flex md:hidden justify-between items-center px-4 py-3 bg-[#1a1a1a] text-white rounded-full mb-2 mx-[40px]">
            {(!blitzModeActive || user?.role === 'teacher') && (
              <motion.button
                whileTap={{ scale: 0.97 }}
                onClick={handleBack}
                className="text-[24px]"
              >
                &lt;
              </motion.button>
            )}

            <div className="flex items-center space-x-2 gap-4">
              {(!blitzModeActive || user?.role === 'teacher') && (
                <button
                  onClick={() => setQuestionOverviewOpen(prev => !prev)}
                  className="flex items-center justify-center bg-white text-[#1a1a1a] px-4 py-2 rounded-full text-[16px]"
                >
                  {currentQuestion ? (
                    <span>{currentQuestion?.index + 1} of {questions?.length}</span>
                  ) : (
                    <span>Review Session</span>
                  )}
                </button>
              )}

              {blitzModeActive && user?.role !== 'teacher' && currentQuestion && (
                <span className="text-white/40 text-sm font-medium">{currentQuestion.index + 1} / {questions?.length}</span>
              )}

              {!blitzModeActive && (autotutor === true || responseData?.tutorModeActive === true) && !isChatVisible && (
                <motion.button
                  whileTap={{ scale: 0.97 }}
                  onClick={toggleChat}
                  className="flex md:hidden items-center justify-center text-white rounded-full text-[28px]"
                >
                  <FaComments />
                </motion.button>
              )}
            </div>

            {currentQuestion ? (
              (!blitzModeActive || user?.role === 'teacher' || currentQuestion.selectedOption !== null) && (
                <motion.button
                  whileTap={{ scale: 0.97 }}
                  onClick={handleNext}
                  className="text-[24px]"
                >
                  &gt;
                </motion.button>
              )
            ) : (
              !loadingQuestions && responseData?.help !== true && !submitClicked && (
                <motion.button
                  whileTap={{ scale: 0.97 }}
                  onClick={() => {
                    setSubmitClicked(true);
                    handleSubmit();
                  }}
                  className="text-[24px]"
                >
                  &gt;
                </motion.button>
              )
            )}

          </div>

        </div>

        {/* Answer Panel */}
        {showanswer && (
          <div className="w-1/5 border-l overflow-y-auto">
            <div
              dangerouslySetInnerHTML={{ __html: currentQuestion?.rationale }}
              className="p-4 box-item-left"
            />
          </div>
        )}
      </div>

      {/* Modals and Overlays */}
      {showWhiteboard && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
          {/* Whiteboard content */}
        </div>
      )}

      {showDirectionModal && <DirectionModal onClose={closeModal} />}
      {showDirectionModalRef && <ReferenceSheet onClose={closeRefModal} />}
      <motion.div drag style={{
        width: '50%',
        height: '400px',
        position: 'absolute',
        zIndex: 100,
        display: showCalculator ? "inline" : "none",
      }}
        dragConstraints={{
          top: -125,
          right: 500,
          bottom: 300,
          left: -125,
        }}
      >
        <div id="calculator" className="w-full h-full">

        </div>

      </motion.div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        className="fixed inset-0 flex items-center justify-center z-50"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50"
      >
        {/* Modal content */}
      </Modal>
    </div>
  );
};
export default SATQuiz;